import { CustomTypography } from './hidden-typography.styles';

const HiddenTypography = ({ children, ...rest }) => {
  return <CustomTypography {...rest}>{children}</CustomTypography>;
};
export default HiddenTypography;
